import React, { Component, useContext, useEffect } from 'react';
import {
  Animated,
  View,
  StyleSheet,
  Dimensions,
  ScrollView,
  ImageBackground,
  Image,
  Text,
  Linking,
} from 'react-native';

import { Button } from 'react-native-elements';

import { TouchableOpacity } from 'react-native-gesture-handler';
import { useNavigation } from '@react-navigation/native';

import MaskedImageContainer from './MaskedImageContainer';
import Loading from '../components/Loading';
import { Context as ConcertContext } from '../context/ConcertContext';
import ImageBackgroundContainer from './ImageBackgroundContainer';
import { deviceWidth } from '../helpers/deviceHelper';
import { dateElementsExtractor } from '../helpers/dateHelper';

const FIXED_BAR_WIDTH = 280;
const BAR_SPACE = 10;

const styles = StyleSheet.create({
  container: {
    // borderColor: 'red',
    // borderWidth: 5,
    // flex: 1,
    // height: deviceHeight * 0.8,
    // alignItems: 'center',
    // justifyContent: 'center',
  },

  scrollview: {
    // borderColor: 'blue',
    // borderWidth: 3,
    // flex: 1,
    // height: deviceHeight * 0.6,
  },
  contentsContainer: {
    // borderColor: 'red',
    // borderWidth: 3,
    flex: 1,
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingHorizontal: deviceWidth * 0.05,
  },
  dateTimeTextContainer: {
    alignItems: 'center',
  },
  dateText: {
    color: 'white',

    // fontFamily: MPLUS1p_100Thin,
    // fontFamily: MPLUS1p_300Light,
    // fontFamily: MPLUS1p_400Regular,
    fontFamily: 'MPLUS1p_500Medium',
    // fontFamily: MPLUS1p_700Bold,
    // fontFamily: MPLUS1p_800ExtraBold,
    // fontFamily: MPLUS1p_900Black
    //
    fontSize: 20,
    // fontWeight: 'bold',
  },
  timeText: {
    color: 'white',
    // //
    // fontFamily: MPLUS1p_100Thin,
    fontFamily: 'MPLUS1p_300Light',
    // fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: MPLUS1p_500Medium,
    // fontFamily: MPLUS1p_700Bold,
    // fontFamily: MPLUS1p_800ExtraBold,
    // fontFamily: MPLUS1p_900Black
    //
    fontSize: 16,
    // fontWeight: 'bold',
    // fontStyle: 'italic',
  },
  venueText: {
    color: 'white',
    // //
    // fontFamily: MPLUS1p_100Thin,
    // fontFamily: 'MPLUS1p_300Light',
    fontFamily: 'MPLUS1p_400Regular',
    // fontFamily: MPLUS1p_500Medium,
    // fontFamily: MPLUS1p_700Bold,
    // fontFamily: MPLUS1p_800ExtraBold,
    // fontFamily: MPLUS1p_900Black
    //
    fontSize: 18,
    // fontWeight: 'bold',
    // marginTop: deviceWidth * 0.05,
    // fontStyle: 'italic',
  },
  titleText: {
    // or: Family: MPLUS1p_100Thin,
    // fontFamily: MPLUS1p_300Light,
    // fontFamily: MPLUS1p_400Regular,
    // fontFamily: MPLUS1p_500Medium,
    fontFamily: 'MPLUS1p_700Bold',
    // fontFamily: MPLUS1p_800ExtraBold,
    // fontFamily: MPLUS1p_900Black
    // fontFamily: MPLUS1p_900Black
    color: 'white',
    fontSize: 24,
    // fontWeight: 'bold',
    // fontStyle: 'italic',
    // marginTop: deviceWidth * 0.05,
  },
  bookingSection: {
    // borderColor: 'red',
    // borderWidth: 2,
    // justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    // marginTop: deviceWidth * 0.05,
    // padding: deviceWidth * 0.05,
  },
  buttonsContainer: {
    // borderColor: 'green',
    // borderWidth: 3,
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  viewDetailButton: {
    width: deviceWidth * 0.3,
  },
  bookingButton: {
    width: deviceWidth * 0.3,
  },
  bookingEndContainer: {
    // borderColor: 'blue',
    // borderWidth: 3,
    alignItems: 'center',
    // alignSelf: 'center',
  },
  bookingEnd: {
    fontFamily: 'MPLUS1p-300Light',
    fontSize: 18,
    color: 'red',
  },
  bookingByPhoneText: {
    fontFamily: 'MPLUS1p-300Light',
    fontSize: 18,
    color: 'white',
  },
  bookingByEmailText: {
    fontFamily: 'MPLUS1p-300Light',
    fontSize: 18,
    color: 'white',
  },

  barContainer: {
    borderColor: 'purple',
    borderWidth: 10,
    // position: 'absolute',
    // zIndex: 2,
    // top: deviceHeight * 0.4,
    // left: deviceWidth * 0.2,
    // top: 40,
    flexDirection: 'row',
  },
  track: {
    backgroundColor: '#ccc',
    overflow: 'hidden',
    height: 2,
  },
  bar: {
    backgroundColor: '#5294d6',
    height: 2,
    // position: 'absolute',
    // left: 0,
    // top: 0,
  },
});

class ScreenTopCarousel extends Component {
  // numItems = concertData.length;
  // itemWidth = FIXED_BAR_WIDTH / this.numItems - (this.numItems - 1) * BAR_SPACE;
  // animVal = new Animated.Value(0);

  render() {
    const { navigation, state } = this.props;

    const concertData = state;

    const numItems = concertData.length;
    const itemWidth = FIXED_BAR_WIDTH / numItems - (numItems - 1) * BAR_SPACE;
    const animVal = new Animated.Value(0);

    let imageArray = [];
    let barArray = [];
    concertData.forEach((item, i) => {
      const { content } = item;

      const { year, month, day, japaneseDay } = dateElementsExtractor(
        new Date(content.date)
      );
      const thisImage = (
        <View key={content.title}>
          <MaskedImageContainer
            uri={content.imageUrl[0]}
            imageProportionType="a4"
            imageWidthRelativeToDeviceWidth={1}
            maskWidthRelativeToDeviceWidth={1}
            containerWidthRelativeToDeviceWidth={1}
            verticalAlignment="center"
          />

          <ImageBackgroundContainer
            uri={content.imageUrl[0]}
            imageProportionType="a4"
            imageWidthRelativeToDeviceWidth={1.5}
            imageHorizontalAlignment="center"
            imageVerticalAlignment="center"
            containerWidthRelativeToDeviceWidth={deviceWidth}
            containerHeightRelativeToDeviceWidth={300}
            coverColor="#3b3c3d"
            coverOpacity={0.9}
          >
            <View style={styles.contentsContainer}>
              <View style={styles.dateTimeTextContainer}>
                {/* <View style={{ borderColor: 'red', borderWidth: 2 }}> */}
                <Text
                  style={styles.dateText}
                >{`${year}年${month}月${day}日(${japaneseDay})`}</Text>
                <Text style={styles.timeText}>{`${content.time}`}</Text>
              </View>
              {/* <View style={{ borderColor: 'red', borderWidth: 2 }}> */}
              <View>
                <Text style={styles.venueText}>{`${content.venue}`}</Text>
              </View>
              <View>
                {/* <View style={{ borderColor: 'red', borderWidth: 2 }}> */}
                <Text style={styles.titleText}>{`${content.title}`}</Text>
              </View>
              <View style={styles.bookingSection}>
                {!content.bookingAccept ? (
                  <View>
                    <Button
                      style={styles.bookingButton}
                      type="outline"
                      title="詳細"
                      onPress={() => {
                        const {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        } = content;

                        navigation.navigate('ConcertDetail', {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        });
                      }}
                    />

                    <View style={styles.bookingEndContainer}>
                      <Text style={styles.bookingEnd}>予約受付終了</Text>
                    </View>
                  </View>
                ) : null}
                {content.bookingAccept && content.bookingFormLink ? (
                  <View style={styles.buttonsContainer}>
                    <Button
                      style={styles.viewDetailButton}
                      type="outline"
                      title="詳細"
                      onPress={() => {
                        const {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        } = content;

                        navigation.navigate('ConcertDetail', {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        });
                      }}
                    />
                    <Button
                      style={styles.bookingButton}
                      title="Web予約"
                      onPress={() => {
                        Linking.openURL(content.bookingFormLink);
                      }}
                    />
                  </View>
                ) : null}
                {content.bookingAccept &&
                (content.bookingPhoneNumber || content.bookingEmail) ? (
                  <>
                    <Button
                      style={styles.viewDetailButton}
                      type="outline"
                      title="詳細"
                      onPress={() => {
                        const {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        } = content;

                        navigation.navigate('ConcertDetail', {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        });
                      }}
                    />
                    <Text style={styles.bookingByPhoneText}>
                      ご予約(電話またはメール):
                    </Text>
                    <Text style={styles.bookingByPhoneText}>
                      {`${content.bookingPhoneNumber}`}
                    </Text>
                    <Text
                      style={styles.bookingByEmailText}
                    >{`${content.bookingEmail}`}</Text>
                  </>
                ) : null}
                {/* {content.bookingAccept && content.bookingFormLink ? (
                  <View style={styles.buttonsContainer}>
                    <Button
                      style={styles.viewDetailButton}
                      title="詳細"
                      onPress={() => {
                        const {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        } = content;

                        navigation.navigate('ConcertDetail', {
                          imageUrl,
                          title,
                          date,
                          time,
                          venue,
                          price,
                          description,
                          bookingFormLink,
                          bookingAccept,
                          bookingPhoneNumber,
                          bookingEmail,
                        });
                      }}
                    />
                    <Button
                      buttonStyle={styles.bookingButton}
                      title="Web予約"
                      onPress={() => {
                        Linking.openURL(content.bookingFormLink);
                      }}
                    />
                  </View>
                ) : null}
                {(content.bookingAccept && content.bookingPhoneNumber) ||
                content.bookingEmail ? (
                  <View>
                    <Text style={styles.bookingByPhoneText}>
                      予約 (お電話またはメール)
                    </Text>
                  </View>
                ) : null}
                {content.bookingAccept && content.bookingPhoneNumber ? (
                  <View>
                    <Text style={styles.bookingByPhoneText}>
                      {content.bookingPhoneNumber}
                    </Text>
                  </View>
                ) : null}
                {content.bookingEmail ? (
                  <View>
                    <Text
                      style={styles.bookingByEmailText}
                    >{`${content.bookingEmail}`}</Text>
                  </View>
                ) : null}
                {!content.bookingAccept ? (
                  <View style={styles.bookingEndContainer}>
                    <Text style={styles.bookingEnd}>予約受付終了</Text>
                  </View>
                ) : null} */}
              </View>
            </View>
          </ImageBackgroundContainer>
        </View>
      );
      imageArray.push(thisImage);

      const scrollBarVal = animVal.interpolate({
        inputRange: [deviceWidth * (i - 1), deviceWidth * (i + 1)],
        outputRange: [-itemWidth, itemWidth],
        extrapolate: 'clamp',
      });

      const thisBar = (
        <View
          key={`bar${i}`}
          style={[
            styles.track,
            {
              width: itemWidth,
              marginLeft: i === 0 ? 0 : BAR_SPACE,
            },
            // { borderColor: 'yellow', borderWidth: 3 },
          ]}
        >
          <Animated.View
            style={[
              styles.bar,
              {
                width: itemWidth,
                transform: [{ translateX: scrollBarVal }],
              },
              // { borderColor: 'yellow', borderWidth: 3 },
            ]}
          />
        </View>
      );
      barArray.push(thisBar);
    });

    return (
      <View style={styles.container}>
        {state.length !== 0 ? (
          <ScrollView
            contentContainerStyle={styles.scrollview}
            horizontal
            showsHorizontalScrollIndicator={false}
            scrollEventThrottle={10}
            pagingEnabled
            onScroll={Animated.event([
              { nativeEvent: { contentOffset: { x: animVal } } },
            ])}
          >
            {imageArray}
            {/* <View style={styles.barContainer}>{barArray}</View> */}
          </ScrollView>
        ) : (
          <Loading />
        )}
      </View>
    );
  }
}

export default function ScreenTopCarouseFunction(props) {
  const navigation = useNavigation();
  const { state, fetchConcertInfo } = useContext(ConcertContext);

  useEffect(() => {
    fetchConcertInfo();
  }, []);

  return (
    <ScreenTopCarousel
      {...props}
      navigation={navigation}
      state={state}
      fetchConcertInfo={fetchConcertInfo}
    />
  );
}
